import React from "react"
export const CommunicationDetailContext = React.createContext(null);

export const useCommunicationDetailContext = () => {

    const context = React.useContext(CommunicationDetailContext);

    if (!context) throw new Error("Communication Detail Context not provided!");

    return context;
}